var styleDataHash = "9ac04e83";
const injectCss = () => {
  var css = `.HkhFM{display:flex}[dir] .HkhFM{margin:0}.MRCi4{color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#116dff));font-size:inherit;font-weight:inherit;line-height:28px;max-width:270px;overflow:hidden;text-decoration:none;text-overflow:ellipsis;white-space:nowrap}[dir] .MRCi4{margin:0;padding:0 4px}.MRCi4:hover{text-decoration:underline}.MRCi4:focus{outline:5px auto Highlight!important;outline:5px auto -webkit-focus-ring-color!important}.MRCi4.S-jTc{line-height:32px}[dir] .sZkCc{background:transparent;border:0}[dir] .sZkCc:hover{cursor:pointer}@supports not (contain:inline-size){@media only screen and (max-width:640px){.MRCi4{max-width:160px}}}@container (width < 640px){.MRCi4{max-width:160px}}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var url_link_button_default = {
  "toolbarUrlContainer": "HkhFM",
  "toolbarUrl": "MRCi4",
  "isMobile": "S-jTc",
  "toolbarUrlAnchor": "sZkCc"
};
export {
  url_link_button_default as default,
  injectCss
};
//# sourceMappingURL=url-link-button-scss.js.map
